module.exports = true;



//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime-corejs2/node_modules/core-js/library/modules/_library.js
// module id = 62
// module chunks = 0